module.exports = __webpack_public_path__ + "static/fonts/iconfont.bb057a1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.woff?t=1627006594184
// module id = 59oK
// module chunks = 78